/* eslint-disable */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import {
  Tabs,
  Tab,
  Paper,
  IconButton,
  TextField,
  Button,
  Tooltip,
  Badge,
  Chip,
} from "@material-ui/core";
import {
  MailOutline,
  Close,
  CheckCircle,
  Cancel,
  MoreHoriz,
  PriorityHigh,
} from "@material-ui/icons";
import { ThreeDots } from "react-loader-spinner";
import { approvalsApi } from "../../services/approvalsApi";

/* ­──────────── util simples ─────────── */
const baseCard = {
  background: "#fff",
  border: "1px solid #ccc",
  //borderRadius: 6,
  padding: 8,
};

/* ­───────────────────────────────────── */
export default function ApprovalsFloating({
  t,
  clientColor,
  classes,
  approvalsData,
  approvalsLoaded = false,
  onInitiativeClick,
  onReloadApprovals,
  onReloadInitiatives,
}) {
  /* estado visuais */
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [loadingId, setLoadingId] = useState(null);

  //  state para os dados de aprovação de dados
  const [dataApprovals, setDataApprovals] = useState([]);
  const [dataApprovalsLoaded, setDataApprovalsLoaded] = useState(false);

  /* dados quando NÃO vêm pré-carregados */
  const [localFullLoaded, setLocalFullLoaded] = useState(false); // tudo
  const [localPrefetched, setLocalPrefetched] = useState(false); // só inbox
  const [localData, setLocalData] = useState({
    actions: [],
    flows: [],
    history: [],
  });

  /* ── pré-carrega caixa de entrada p/ badge ── */
  useEffect(() => {
    if (approvalsData || localPrefetched) return;
    approvalsApi.inbox().then((d) => {
      setLocalData((p) => ({ ...p, actions: d.actions || [] }));
      setLocalPrefetched(true);
    });
  }, [approvalsData, localPrefetched]);

  /* ── carrega tudo quando abrir (se preciso) ── */
  useEffect(() => {
    if (approvalsData || !open || localFullLoaded) return;
    Promise.all([
      approvalsApi.inbox(),
      approvalsApi.myInitiatives(),
      approvalsApi.myHistory(),
    ]).then(([a, f, h]) => {
      setLocalData({
        actions: a.actions || [],
        flows: f.flows || [],
        history: h.history || [],
      });
      setLocalFullLoaded(true);
    });
  }, [open, approvalsData, localFullLoaded]);

  // NOVO: useEffect para buscar a nova inbox de dados
  useEffect(() => {
    if (open) {
      // Apenas busca quando o painel está aberto
      approvalsApi
        .dataInbox()
        .then((response) => {
          if (response.success) {
            setDataApprovals(response.pending_changes || []);
          }
          setDataApprovalsLoaded(true);
        })
        .catch(() => setDataApprovalsLoaded(true)); // Garante que o loading para mesmo em caso de erro
    }
  }, [open]);

  // Função para recarregar tudo
  const reloadAll = async () => {
    // Recarrega a inbox de stage changes (lógica existente)
    onReloadApprovals();
    // NOVO: Recarrega a inbox de data changes
    const response = await approvalsApi.dataInbox();
    if (response.success) {
      setDataApprovals(response.pending_changes || []);
    }
    // Recarrega as iniciativas na lista principal
    onReloadInitiatives();
  };

  // Função para aprovar/rejeitar e recarregar
  const handleDataAction = async (pendingChangeId, result, comment = "") => {
    setLoadingId(pendingChangeId);
    await approvalsApi.dataAction({
      pending_change_id: pendingChangeId,
      action: result,
      comment,
    });
    await reloadAll();
    setLoadingId(null);
  };

  /*  fonte de dados  */
  const dataReady = approvalsData ? approvalsLoaded : localFullLoaded;
  const { actions, flows, history } = approvalsData || localData;

  /* ───────── FAB (ícone) ───────── */
  const Fab = (
    <Draggable grid={[1, 1]}>
      <div
        style={{
          position: "fixed",
          right: 16,
          bottom: 16,
          zIndex: 1300,
          touchAction: "none",
        }}
      >
        <Badge
          badgeContent={actions.length || null}
          color="error"
          overlap="circle"
          invisible={actions.length === 0}
        >
          <IconButton
            style={{
              background: "#fff",
              color: "#333",
              border: "1px solid #ccc",
            }}
            onClick={() => setOpen((o) => !o)}
          >
            <MailOutline />
          </IconButton>
        </Badge>
      </div>
    </Draggable>
  );
  if (!open) return Fab;

  /* ───────── Painel ───────── */
  return (
    <>
      {Fab}

      <Draggable
        handle=".drag-bar"
        defaultPosition={{
          x: window.innerWidth / 2 - 410,
          y: window.innerHeight / 2 - 280,
        }}
        grid={[1, 1]}
      >
        <Paper
          elevation={4}
          style={{
            position: "fixed",
            width: "45vw",
            maxWidth: 820,
            height: "70vh",
            display: "flex",
            flexDirection: "column",
            zIndex: 1299,
            touchAction: "none",
          }}
        >
          {/* barra drag */}
          <div
            className="drag-bar"
            style={{
              cursor: "move",
              background: clientColor,
              color: "#fff",
              padding: "4px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <strong>{t("approvals.inbox_title")}</strong>
            <IconButton
              size="small"
              style={{ color: "#fff" }}
              onClick={() => setOpen(false)}
            >
              <Close fontSize="small" />
            </IconButton>
          </div>

          {/* spinner ou conteúdo */}
          {!dataReady ? (
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ThreeDots color={clientColor} height={60} width={60} visible />
            </div>
          ) : (
            <>
              <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant="fullWidth"
                classes={{ indicator: classes.indicator }}
                TabIndicatorProps={{ style: { backgroundColor: clientColor } }}
              >
                <Tab
                  label={t("approvals.actions")}
                  classes={{ root: classes.tabRoot }}
                />
                <Tab
                  label={t("approvals.my_initiatives")}
                  classes={{ root: classes.tabRoot }}
                />
                <Tab
                  label={t("approvals.data_changes")}
                  classes={{ root: classes.tabRoot }}
                />
              </Tabs>

              <div style={{ flex: 1, overflow: "auto", padding: 8 }}>
                {tab === 0 && (
                  <ActionsBlock
                    t={t}
                    actions={actions}
                    history={history}
                    clientColor={clientColor}
                    loadingId={loadingId}
                    setLoadingId={setLoadingId}
                    classes={classes}
                    onInitiativeClick={onInitiativeClick}
                    onReloadApprovals={onReloadApprovals}
                    onReloadInitiatives={onReloadInitiatives}
                    refresh={async () => {
                      const d = await approvalsApi.inbox();
                      if (approvalsData)
                        approvalsData.actions = d.actions || [];
                      else
                        setLocalData((p) => ({
                          ...p,
                          actions: d.actions || [],
                        }));
                    }}
                  />
                )}
                {tab === 1 && <MyInitiativesBlock t={t} flows={flows} />}
                {tab === 2 && (
                  <DataChangesBlock
                    t={t}
                    pendingChanges={dataApprovals}
                    loadingId={loadingId}
                    onAction={handleDataAction}
                    onInitiativeClick={onInitiativeClick}
                  />
                )}
              </div>
            </>
          )}
        </Paper>
      </Draggable>
    </>
  );
}

function DataChangesBlock({
  t,
  pendingChanges,
  loadingId,
  onAction,
  onInitiativeClick,
}) {
  if (pendingChanges.length === 0) {
    return <Empty>{t("approvals.no_data_changes_pending")}</Empty>;
  }

  const objectTypeToSectionMap = {
    onepageinitiative: "one_page",
    deliverable: "execution",
    initiativevalue: "results",
    // Adicione outros mapeamentos se necessário
  };

  return (
    <div>
      {pendingChanges.map((pc) => {
        const targetSection =
          objectTypeToSectionMap[pc.object_type.toLowerCase()] || "details";

        // Todo o JSX para uma pendência está dentro de um único elemento raiz retornado
        return (
          <div key={pc.id} style={{ ...baseCard, marginBottom: 12 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                onClick={() =>
                  onInitiativeClick(pc.initiative_id, targetSection)
                }
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {pc.summary}
              </div>

              {/* O JSX dos botões agora está corretamente aninhado */}
              {loadingId === pc.id ? (
                <ThreeDots color="#000" height={24} width={24} />
              ) : (
                <div style={{ display: "flex" }}>
                  <Tooltip title={t("approvals.reject")}>
                    <IconButton
                      size="small"
                      onClick={() => onAction(pc.id, "reject")}
                    >
                      <Cancel style={{ color: "#e04f5f" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("approvals.approve")}>
                    <IconButton
                      size="small"
                      onClick={() => onAction(pc.id, "approve")}
                    >
                      <CheckCircle style={{ color: "green" }} />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
            </div>

            <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
              {t("approvals.requested_by")} {pc.requested_by}{" "}
              {t("approvals.at")} {new Date(pc.requested_at).toLocaleString()}
            </div>
          </div>
        ); // O return agora engloba todo o elemento
      })}
    </div>
  );
}

/* ───────── bloco Actions (agrupado por iniciativa) ───────── */
function ActionsBlock({
  t,
  actions,
  history,
  refresh,
  loadingId,
  setLoadingId,
  clientColor,
  classes,
  onInitiativeClick,
  onReloadApprovals,
  onReloadInitiatives,
}) {
  const [comment, setComment] = useState({});
  const [confirmData, setConfirmData] = useState(null);

  const act = async () => {
    const { id, result } = confirmData;
    setConfirmData(null);
    setLoadingId(id);
    await approvalsApi.act({
      actionId: id,
      result,
      comment: comment[id] || "",
    });

    // 3. CHAME A FUNÇÃO DE RECARREGAMENTO APÓS A AÇÃO
    if (onReloadInitiatives) {
      await onReloadInitiatives();
    }

    // Recarrega o próprio inbox de aprovações
    await refresh();
    setLoadingId(null);
  };

  // filtro antes de agrupar
  const visibleActions = actions.filter(
    (a) => a.result === null || a.result === "REV"
  );

  const grouped = visibleActions.reduce((acc, a) => {
    (acc[a.initiative] ||= []).push(a);
    return acc;
  }, {});

  return (
    <>
      {actions.length ? (
        Object.entries(grouped).map(([initiative, list]) => (
          <div key={initiative} style={{ ...baseCard, marginBottom: 12 }}>
            {/* Cabeçalho da iniciativa */}
            <div
              onClick={() =>
                typeof onInitiativeClick === "function" &&
                onInitiativeClick(list[0].initiative_id || list[0].initiativeId)
              }
              style={{
                fontWeight: 600,
                marginBottom: 4,
                cursor: "pointer",
                textDecoration: "underline",
                //color: clientColor,
              }}
            >
              {initiative}
            </div>

            {list.map((a) => (
              <div
                key={a.id}
                style={{
                  display: "flex",
                  gap: 12,
                  padding: 8,
                  borderTop: "1px dashed #ccc",
                  borderRadius: 4,
                  marginBottom: 0,
                  marginTop: 8,
                }}
              >
                {/* Flow & textarea */}
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#666", fontSize: 13, fontWeight: 400 }}>
                    {a.flow}
                  </div>
                  <TextField
                    variant="outlined"
                    size="small"
                    multiline
                    placeholder={t("approvals.comment_placeholder")}
                    fullWidth
                    value={comment[a.id] || ""}
                    onChange={(e) =>
                      setComment({ ...comment, [a.id]: e.target.value })
                    }
                    helperText={`${(comment[a.id] || "").length}/600`}
                    inputProps={{ maxLength: 600 }}
                    InputProps={{
                      classes: {
                        root: classes.outlinedInputv2,
                        input: classes.inputText,
                      },
                      style: { fontSize: 12 },
                    }}
                    FormHelperTextProps={{ style: { fontSize: 8 } }}
                    style={{ marginTop: 6 }}
                  />
                </div>

                {/* botões */}
                <div
                  style={{
                    minWidth: 64,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {loadingId === a.id ? (
                    <ThreeDots color={clientColor} height={24} width={24} />
                  ) : (
                    <>
                      <Tooltip title={t("approvals.approve")}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmData({ id: a.id, result: "APP" })
                          }
                        >
                          <CheckCircle style={{ color: "green" }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t("approvals.reject")}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmData({ id: a.id, result: "REJ" })
                          }
                        >
                          <Cancel style={{ color: "#e04f5f" }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t("approvals.review")}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmData({ id: a.id, result: "REV" })
                          }
                        >
                          <PriorityHigh style={{ color: "#999" }} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        <Empty>{t("approvals.no_pending")}</Empty>
      )}

      {/* Confirmação */}
      {confirmData && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1500,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 24,
              borderRadius: 6,
              width: 300,
              textAlign: "center",
            }}
          >
            <div style={{ marginBottom: 16 }}>
              {t("approvals.confirm_action")}
            </div>
            <Button onClick={() => setConfirmData(null)}>{t("cancel")}</Button>
            <Button
              variant="contained"
              style={{ background: clientColor, color: "#fff", marginLeft: 8 }}
              onClick={act}
            >
              {t("confirm")}
            </Button>
          </div>
        </div>
      )}

      {/* histórico */}

      {history.length > 0 && (
        <>
          <h4
            style={{
              margin: "16px 4px 4px",
              textTransform: "uppercase",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            {t("approvals.my_history")}
          </h4>

          <div style={{ ...baseCard, maxHeight: 160, overflow: "auto" }}>
            {history.map((h) => {
              /* define estilo/ícone conforme resultado */
              let icon = null;
              let color = "";
              if (h.result === "APP") {
                icon = <CheckCircle />;
                color = "green";
              } else if (h.result === "REJ") {
                icon = <Cancel />;
                color = "#E04F5F";
              } else if (h.result === "REV") {
                icon = <MoreHoriz />;
                color = "#999";
              } else if (h.result === "ABT") {
                icon = <PriorityHigh />;
                color = "#bbb";
              }

              return (
                <div
                  key={h.id}
                  style={{
                    fontSize: 13,
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 6,
                    /* semi-transparente se ABT */
                    opacity: h.result === "ABT" ? 0.45 : 1,
                  }}
                >
                  {icon &&
                    React.cloneElement(icon, {
                      style: { color, marginRight: 6, fontSize: 18 },
                    })}
                  <span>
                    <strong>{h.initiative}</strong> — {h.flow}
                  </span>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

/* ───────── bloco Minhas iniciativas (sem mudança) ───────── */
function MyInitiativesBlock({ t, flows }) {
  if (!flows.length) return <Empty>{t("approvals.no_items")}</Empty>;

  const grouped = flows.reduce((acc, f) => {
    (acc[f.initiative] ||= []).push(f);
    return acc;
  }, {});

  return Object.entries(grouped).map(([initiative, list]) => (
    <div key={initiative} style={{ ...baseCard, marginBottom: 16 }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{initiative}</div>

      {list.map((f) => {
        const ct = { APP: 0, REJ: 0, PEND: 0 };
        f.steps.forEach((s) => {
          ct.APP += s.result === "APP" ? 1 : 0;
          ct.REJ += s.result === "REJ" ? 1 : 0;
          ct.PEND += !s.result ? 1 : 0;
        });

        return (
          <div key={f.id} style={{ marginTop: 4 }}>
            <div style={{ fontWeight: 500 }}>{f.flow}</div>
            <div style={{ display: "flex", gap: 8, marginTop: 2 }}>
              {ct.APP > 0 && (
                <Chip
                  size="small"
                  label={`${ct.APP} ${t("approvals.approved")}`}
                  icon={<CheckCircle />}
                />
              )}
              {ct.REJ > 0 && (
                <Chip
                  size="small"
                  label={`${ct.REJ} ${t("approvals.rejected")}`}
                  color="secondary"
                  icon={<Cancel />}
                />
              )}
              {ct.PEND > 0 && (
                <Chip
                  size="small"
                  variant="outlined"
                  label={`${ct.PEND} ${t("approvals.pending")}`}
                  icon={<MoreHoriz />}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  ));
}

/* ───────── vazio ───────── */
const Empty = ({ children }) => (
  <div style={{ padding: 24, fontStyle: "italic", fontSize: 14 }}>
    {children}
  </div>
);

/* ───────── PropTypes (parciais) ───────── */
ApprovalsFloating.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object,
  clientColor: PropTypes.string,
  approvalsData: PropTypes.object,
  approvalsLoaded: PropTypes.bool,
  onInitiativeClick: PropTypes.func,
};

ActionsBlock.propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.array.isRequired,
  history: PropTypes.array.isRequired,
  refresh: PropTypes.func.isRequired,
  loadingId: PropTypes.any,
  setLoadingId: PropTypes.func.isRequired,
  clientColor: PropTypes.string.isRequired,
  classes: PropTypes.object,
  onInitiativeClick: PropTypes.func,
};

MyInitiativesBlock.propTypes = {
  t: PropTypes.func.isRequired,
  flows: PropTypes.array.isRequired,
};
